export const DOWNPAYMENT_REQUIRED_ERROR = 'Please, enter the down payment';
export const PERIOD_REQUIRED_ERROR = 'Please, select an option';
